import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { useApiConfiguration } from '../../contexts';
import { FormattedMessage } from '../FormattedMessage';
import { BasketLink, Root } from './styles';
import type { HeaderProps } from './types';

export const Header: FC<HeaderProps> = ({ quantity }) => {
  const { apiConfiguration: { goToBasketUrl } = {} } = useApiConfiguration();
  const { getTestId } = useTestId();

  return (
    <Root data-testid={getTestId('header')}>
      <Typography variant="h6">
        <BasketLink
          href={goToBasketUrl}
          data-testid={getTestId('header-basket-link')}
        >
          <FormattedMessage id="basket" /> ({quantity.toString()})
        </BasketLink>
      </Typography>
    </Root>
  );
};
